export const t = (key, params = {}) => {
    const keys = key.split('.')
    let translation = window.sms_ir_login?.translations

    for (const k of keys) {
        translation = translation?.[k]
        if (!translation) return key
    }
    
    if (typeof translation === 'string') {
        return translation.replace(/{(\w+)}/g, (match, p1) => 
            params[p1] || match
        )
    }
    
    return translation
}
